import React, { useContext, useEffect } from "react";
import { Tag, Table, Space, message } from "antd";
import moment from "moment";
import FilesContext from "../../../context/files/filesContext";
import Text from "antd/lib/typography/Text";
import config from "../../../config";

const TableManualUploadFiles = () => {
  const STATUS_FILE = {
    PENDIENTE: "Pendiente",
    EJECUTANDO: "Ejecutando",
    FINALIZADO: "Finalizado",
    ERROR: "Error",
  };

  const filesContext = useContext(FilesContext);

  const { loading, files, getFiles } = filesContext;

  useEffect(() => {
    getFiles();
  }, []);

  const handleDownload = async (e, id, fileName) => {
    e.preventDefault();
    try {
      const response = await fetch(`${config.backendUrl}/api/file/${id}/download`);
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        const errorData = await response.json();
        message.error(errorData.message || "El archivo no se encuentra disponible");
      }
    } catch (error) {
      console.error("Download error:", error);
      message.error("Error al intentar descargar el archivo");
    }
  };

  const marginP = { margin: 0 };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "0",
      width: "10%",
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "1",
    },
    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "2",
      render: (text) => (
        <p style={marginP}>{moment(text).format("DD-MM-YYYY")}</p>
      ),
    },
    {
      title: "usuario",
      dataIndex: "codigoEmpleado",
      key: "3",
      render: (text) => (
        <Text style={{textTransform: 'capitalize'}}>{text}</Text>
      ),
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "4",
      render: (status) => (
        <Tag
          color={
            status.trim() === "P"
              ? "blue"
              : status.trim() === "E"
              ? "gold"
              : status.trim() === "F"
              ? "green"
              : "red"
          }
        >
          {status.trim() === "P"
            ? STATUS_FILE.PENDIENTE
            : status.trim() === "E"
            ? STATUS_FILE.EJECUTANDO
            : status.trim() === "F"
            ? STATUS_FILE.FINALIZADO
            : "Error"}
        </Tag>
      ),
    },
    {
      title: "Acciones",
      key: "action",
      render: (text, data) => (
        <>
          <Space size="large">
            <>
              <a style={marginP} href={"archivos-detalle/" + data.id}>
                Ver
              </a>
              <a
                href="#"
                onClick={(e) => handleDownload(e, data.id, data.nombre)}
              >
                Descargar
              </a>
            </>
          </Space>
        </>
      ),
    },
  ];

  return (
    <>
      <Table
        key="3"
        dataSource={files}
        columns={columns}
        loading={loading}
        scroll={{ x: "auto" }}
        rowKey="id"
      />
    </>
  );
};

export default TableManualUploadFiles;
